import { configureStore } from '@reduxjs/toolkit'
import deviceReducer from '../store/deviceSlice';
import loadTimeReducer from '../store/loadTimeSlice';
import contentReducer from '../store/contentSlice';

export default configureStore({
  reducer: {
    device: deviceReducer,
    loadTime: loadTimeReducer,
    content: contentReducer
  }
})